// import {
// GetAppConfigByKeyRequest,
// InvestmentTokenCriteria,
// TokenCriteria,
// } from 'core/models/app-config/get-app-config-by-key.model';
// import { AppConfigurationKey } from 'core/models/app-config/get-app-config.model';
// import { AppConfigV1BaseServerRepo } from 'core/repository/base-server/v1/app-config.repo';
import { useEffect, useState } from 'react';
// import { mapDecimalToUnit } from 'utils/format';
// import Web3 from 'web3';
// import MIN_ABI from '../../../assets/ABI/Min.abi.json';
import { useProfile } from './profile';
import { WalletType } from 'core/models/users/wallet/wallet-address.model';
// import { usePublicClient } from 'wagmi';
// import erc20Abi from 'components/io/erc20.json';
// import { formatUnits } from 'viem';
import alchemy from './alchemy';
import { getEthBalance } from 'components/io/participateInLottery';
// import axios from 'axios';

export interface WalletCurrency {
  balance: number;
  symbol: string;
  name: string;
  decimals: number;
  contractAddress: `0x${string}`;
  logo: string;
  cryptoNetworkId: number;
  explorer?: string;
}

export const useWallet = (
  wallet: WalletType
): [WalletCurrency[], () => void] => {
  const { profile } = useProfile();
  const [currencies, setCurrencies] = useState<WalletCurrency[]>();
  // const publicClient = usePublicClient();

  // async function fetchBalance(
  //   criteria: TokenCriteria,
  //   profile: ProfileDetails
  // ): Promise<number> {
  //   try {
  //     // const web3 = new Web3(criteria?.endPoint);
  //     // const tokenContract = new web3.eth.Contract(
  //     //   MIN_ABI,
  //     //   criteria?.contractAddress
  //     // );
  //     const decimals = (await publicClient?.readContract({
  //       abi: erc20Abi,
  //       address: criteria?.contractAddress,
  //       functionName: 'decimals',
  //     })) as number;

  //     // const decimals = (await contract.methods.decimals().call()) as number;
  //     //  const formattedAmount = parseUnits(
  //     //    amount.toString(),
  //     //    decimals
  //     //  );
  //     // const decimals = (await tokenContract.methods
  //     //   .decimals()
  //     //   .call()) as number;
  //     const balance = (await publicClient?.readContract({
  //       abi: erc20Abi,
  //       address: criteria?.contractAddress,
  //       functionName: 'balanceOf',
  //       args: [profile.wallets?.get(wallet)],
  //     })) as bigint;

  //     const formattedBalance = formatUnits(balance, decimals);
  //     // );
  //     // console.log(`Balance: ${formattedBalance}`);
  //     return Number(formattedBalance);
  //   } catch (error) {
  //     return 0;
  //   }
  // }

  async function refresh() {
    // const criteriaRequest: GetAppConfigByKeyRequest = {
    //   key: AppConfigurationKey.INVESTMENT_CRITERIA,
    // };

    // const criteriaa = (
    //   await new AppConfigV1BaseServerRepo().getByKey(criteriaRequest)
    // )[AppConfigurationKey.INVESTMENT_CRITERIA] as InvestmentTokenCriteria;
    if (profile) {
      try {
        const balanceData = await alchemy.core.getTokenBalances(
          profile.wallets?.get(wallet) as string
        );
        // console.log(' balanceData.tokenBalances--', balanceData.tokenBalances)
        // Filter out tokens with zero balances
        const nonZeroBalances = balanceData.tokenBalances.filter(
          (token) => token.tokenBalance !== '0'
        );

        // Fetch token metadata for each token
        const tokenDataPromises = nonZeroBalances.map(async (token) => {
          const metadata = await alchemy.core.getTokenMetadata(
            token.contractAddress
          );
          return {
            symbol: metadata.symbol ? metadata.symbol : '',
            name: metadata.name ? metadata.name : '',
            balance: token.tokenBalance,
            decimals: metadata.decimals ? metadata.decimals : 0,
            contractAddress: token.contractAddress as `0x${string}`,
            logo: metadata.symbol ? metadata.symbol.toLocaleLowerCase() : '',
            cryptoNetworkId: Number(process.env.REACT_APP_CHAIN_ID),
          };
        });

        const tokenData = await Promise.all(tokenDataPromises);
        // const COINGECKO_API_KEY = "CG-91drsXzBFsPvxzrcyMGJSiNK";

        // const contractAddresses = tokenData.map((token) => token.contractAddress.toLowerCase());
        // const coingeckoResponse = await axios.get(
        //   `https://pro-api.coingecko.com/api/v3/simple/token_price/base`,
        //   {
        //     params: {
        //       contract_addresses: contractAddresses.join(","),
        //       vs_currencies: "usd",
        //       x_cg_pro_api_key: COINGECKO_API_KEY, // Include your API key here
        //     },
        //   }
        // );

        // const prices = coingeckoResponse.data;

        // Format the balances
        const formattedBalances = tokenData.map((token) => {
          // const priceInfo = prices[token.contractAddress.toLowerCase()] || { usd: 0 };
          return {
            ...token,
            // usdPrice: priceInfo.usd,
            balance:
              token.balance && token.decimals
                ? Number(BigInt(token.balance) / BigInt(10 ** token.decimals))
                : 0,
          };
        });

        const ethBalRes = await getEthBalance(profile.wallets?.get(wallet));

        formattedBalances.push({
          balance: ethBalRes ? Number(ethBalRes) : 0,
          symbol: 'ETH',
          name: 'ETH',
          decimals: 18,
          contractAddress: `0x`,
          logo: 'eth',
          cryptoNetworkId: Number(process.env.REACT_APP_CHAIN_ID),
        });

        // console.log('formattedBalances----', formattedBalances);
        setCurrencies(formattedBalances);
      } catch (error) {
        console.log('Error in price fetch--', error);
        // setCurrencies([])
      }
    }

    // const criteria = [
    //   {
    //     logo: 'bcnx',
    //     amount: 100000,
    //     symbol: '$BCNX',
    //     endPoint:
    //       'https://arbitrum-sepolia.infura.io/v3/40019aad67294bbf8ad8e519a05f9ba3',
    //     isNativeToken: false,
    //     contractAddress: process.env.REACT_APP_BCNX_ADDRESS as `0x${string}`,
    //     cryptoNetworkId: Number(process.env.REACT_APP_CHAIN_ID),
    //   },
    //   {
    //     logo: 'usdt',
    //     amount: 100000,
    //     symbol: '$USDT',
    //     endPoint:
    //       'https://arbitrum-sepolia.infura.io/v3/40019aad67294bbf8ad8e519a05f9ba3',
    //     isNativeToken: false,
    //     contractAddress: process.env.REACT_APP_USDC_ADDRESS as `0x${string}`,
    //     cryptoNetworkId: Number(process.env.REACT_APP_CHAIN_ID),
    //   },
    // ];
    // const balances: number[] = await Promise.all(
    //   criteria.map((c) => fetchBalance(c, profile!))
    // );
    // const currencies = criteria.map((c, i) => ({ ...c, balance: balances[i] }));
    // setCurrencies(currencies);
    //await new Promise((resolve) => setTimeout(resolve, 5000));
  }

  useEffect(() => {
    if (!profile) return;
    refresh();
  }, [profile]);

  return [currencies!, refresh];
};
